import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'

export const Contact = () => {
  const staticBlockID = CMS_BLOCK.FOOTER_CONTACT
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  })

  if (!staticBlock.content) return null

  return (
    <Container>
      {staticBlock.content && (
        <div
          dangerouslySetInnerHTML={{
            __html: staticBlock.content
          }}
        />
      )}
    </Container>
  )
}
